// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// /**
//  * Convert image URL to base64 with CORS handling
//  */
// const imageUrlToBase64 = async (url) => {
//   try {
//     // Try multiple methods to fetch the image
//     let blob;

//     // Method 1: Direct fetch with CORS
//     try {
//       const response = await fetch(url, {
//         mode: "cors",
//         credentials: "omit",
//         referrerPolicy: "no-referrer",
//       });
//       blob = await response.blob();
//     } catch (fetchError) {
//       console.warn("Direct fetch failed, trying proxy method:", fetchError);

//       // Method 2: Create image element and draw to canvas
//       return new Promise((resolve, reject) => {
//         const img = new Image();
//         img.crossOrigin = "anonymous";
//         img.referrerPolicy = "no-referrer";

//         img.onload = () => {
//           try {
//             const canvas = document.createElement("canvas");
//             canvas.width = img.width;
//             canvas.height = img.height;
//             const ctx = canvas.getContext("2d");
//             ctx.drawImage(img, 0, 0);
//             resolve(canvas.toDataURL("image/png"));
//           } catch (canvasError) {
//             console.error("Canvas conversion failed:", canvasError);
//             reject(canvasError);
//           }
//         };

//         img.onerror = (error) => {
//           console.error("Image load failed:", error);
//           reject(error);
//         };

//         // Add timestamp to bypass cache
//         img.src = url.includes("?")
//           ? `${url}&t=${Date.now()}`
//           : `${url}?t=${Date.now()}`;
//       });
//     }

//     // Convert blob to base64
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = () => resolve(reader.result);
//       reader.onerror = reject;
//       reader.readAsDataURL(blob);
//     });
//   } catch (error) {
//     console.error("Failed to convert image to base64:", error);
//     return null;
//   }
// };

// /**
//  * Common configuration for html2canvas
//  */
// const getCanvasConfig = (element) => ({
//   scale: 3,
//   useCORS: true,
//   allowTaint: false,
//   logging: false,
//   backgroundColor: "#ffffff",
//   scrollY: -window.scrollY,
//   scrollX: -window.scrollX,
//   windowWidth: element.scrollWidth,
//   windowHeight: element.scrollHeight,
//   onclone: async (clonedDoc) => {
//     const el = clonedDoc.querySelector(".receipt-card");

//     if (el) {
//       el.style.display = "block";
//       el.style.margin = "0";
//       el.style.padding = "0";
//       el.style.position = "static";
//       el.style.transform = "none";
//       el.style.maxWidth = "650px";
//       el.style.width = "650px";
//       el.style.boxSizing = "border-box";

//       // Make everything visible
//       const allElements = el.querySelectorAll("*");
//       allElements.forEach((child) => {
//         child.style.visibility = "visible";
//         child.style.opacity = "1";
//       });

//       // Handle images - Convert to base64 to bypass CORS
//       const images = el.querySelectorAll("img");
//       for (const img of images) {
//         img.style.display = "block";
//         img.style.maxWidth = "100%";
//         img.style.visibility = "visible";
//         img.style.opacity = "1";

//         // Set crossOrigin before loading
//         img.crossOrigin = "anonymous";

//         // Convert external images to base64
//         if (img.src && !img.src.startsWith("data:")) {
//           try {
//             const base64 = await imageUrlToBase64(img.src);
//             if (base64) {
//               img.src = base64;
//             }
//           } catch (error) {
//             console.warn("Failed to convert image:", img.src, error);
//           }
//         }

//         // Ensure image dimensions are set
//         if (!img.style.width && img.naturalWidth) {
//           img.style.width = img.naturalWidth + "px";
//         }
//         if (!img.style.height && img.naturalHeight) {
//           img.style.height = img.naturalHeight + "px";
//         }
//       }
//     }
//   },
// });

// /**
//  * Wait for images to load
//  */
// const waitForImages = (element) => {
//   const images = element.querySelectorAll("img");
//   const promises = Array.from(images).map((img) => {
//     if (img.complete) return Promise.resolve();
//     return new Promise((resolve) => {
//       img.onload = resolve;
//       img.onerror = resolve; // Continue even if image fails
//       setTimeout(resolve, 3000);
//     });
//   });
//   return Promise.all(promises);
// };

// /**
//  * Generate canvas from element
//  */
// const generateCanvas = async (element) => {
//   if (!element) throw new Error("Element not found");

//   await waitForImages(element);
//   await new Promise((resolve) => setTimeout(resolve, 200));

//   const canvas = await html2canvas(element, getCanvasConfig(element));
//   return canvas;
// };

// /**
//  * Download as PNG format
//  */
// export const downloadAsPNG = async (element, filename) => {
//   try {
//     const canvas = await generateCanvas(element);
//     const blob = await new Promise((resolve) => {
//       canvas.toBlob(resolve, "image/png", 1.0);
//     });

//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.download = `${filename}.png`;
//     link.href = url;
//     link.click();

//     setTimeout(() => URL.revokeObjectURL(url), 100);
//   } catch (error) {
//     console.error("Error downloading PNG:", error);
//     throw error;
//   }
// };

// /**
//  * Download as JPEG format
//  */
// export const downloadAsJPEG = async (element, filename) => {
//   try {
//     const canvas = await generateCanvas(element);
//     const blob = await new Promise((resolve) => {
//       canvas.toBlob(resolve, "image/jpeg", 0.95);
//     });

//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.download = `${filename}.jpeg`;
//     link.href = url;
//     link.click();

//     setTimeout(() => URL.revokeObjectURL(url), 100);
//   } catch (error) {
//     console.error("Error downloading JPEG:", error);
//     throw error;
//   }
// };

// /**
//  * Download as PDF format
//  */
// export const downloadAsPDF = async (element, filename) => {
//   try {
//     const canvas = await generateCanvas(element);
//     const imgData = canvas.toDataURL("image/png", 1.0);

//     const canvasWidth = canvas.width;
//     const canvasHeight = canvas.height;

//     const pdfWidth = 200;
//     const pdfHeight = (canvasHeight * pdfWidth) / canvasWidth;

//     const pdf = new jsPDF({
//       orientation: pdfWidth > pdfHeight ? "landscape" : "portrait",
//       unit: "mm",
//       format: [pdfWidth, pdfHeight],
//     });

//     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight, undefined, "FAST");
//     pdf.save(`${filename}.pdf`);
//   } catch (error) {
//     console.error("Error downloading PDF:", error);
//     throw error;
//   }
// };

// /**
//  * Download in specified format
//  */
// export const downloadReceipt = async (element, filename, format) => {
//   if (!element) {
//     throw new Error("Element not found for download");
//   }

//   const validFormats = ["png", "jpeg", "jpg", "pdf"];
//   const normalizedFormat = format.toLowerCase();

//   if (!validFormats.includes(normalizedFormat)) {
//     throw new Error(
//       `Unsupported format: ${format}. Supported formats: ${validFormats.join(
//         ", "
//       )}`
//     );
//   }

//   try {
//     switch (normalizedFormat) {
//       case "png":
//         await downloadAsPNG(element, filename);
//         break;
//       case "jpeg":
//       case "jpg":
//         await downloadAsJPEG(element, filename);
//         break;
//       case "pdf":
//         await downloadAsPDF(element, filename);
//         break;
//       default:
//         throw new Error(`Unsupported format: ${format}`);
//     }
//   } catch (error) {
//     console.error(`Download failed for format ${format}:`, error);
//     throw error;
//   }
// };

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Convert image URL to base64 with CORS handling
 */
const imageUrlToBase64 = async (url) => {
  try {
    // Try multiple methods to fetch the image
    let blob;

    // Method 1: Direct fetch with CORS
    try {
      const response = await fetch(url, {
        mode: "cors",
        credentials: "omit",
        referrerPolicy: "no-referrer",
      });
      blob = await response.blob();
    } catch (fetchError) {
      console.warn("Direct fetch failed, trying proxy method:", fetchError);

      // Method 2: Create image element and draw to canvas
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.referrerPolicy = "no-referrer";

        img.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL("image/png"));
          } catch (canvasError) {
            console.error("Canvas conversion failed:", canvasError);
            reject(canvasError);
          }
        };

        img.onerror = (error) => {
          console.error("Image load failed:", error);
          reject(error);
        };

        // Add timestamp to bypass cache
        img.src = url.includes("?")
          ? `${url}&t=${Date.now()}`
          : `${url}?t=${Date.now()}`;
      });
    }

    // Convert blob to base64
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Failed to convert image to base64:", error);
    return null;
  }
};

/**
 * Common configuration for html2canvas
 */
const getCanvasConfig = (element) => ({
  scale: 3,
  useCORS: true,
  allowTaint: false,
  logging: false,
  backgroundColor: "#ffffff",
  scrollY: -window.scrollY,
  scrollX: -window.scrollX,
  windowWidth: element.scrollWidth,
  windowHeight: element.scrollHeight,
  onclone: async (clonedDoc) => {
    const el = clonedDoc.querySelector(".receipt-card");

    if (el) {
      el.style.display = "block";
      el.style.margin = "0";
      el.style.padding = "0";
      el.style.position = "static";
      el.style.transform = "none";
      el.style.maxWidth = "800px";
      el.style.width = "800px";
      el.style.boxSizing = "border-box";

      // ⭐ FIX: Preserve the border
      el.style.border = "2px solid #333";
      el.style.backgroundColor = "#fff";

      // Make everything visible
      const allElements = el.querySelectorAll("*");
      allElements.forEach((child) => {
        child.style.visibility = "visible";
        child.style.opacity = "1";
      });

      // Handle images - Convert to base64 to bypass CORS
      const images = el.querySelectorAll("img");
      for (const img of images) {
        img.style.display = "block";
        img.style.maxWidth = "100%";
        img.style.visibility = "visible";
        img.style.opacity = "1";

        // Set crossOrigin before loading
        img.crossOrigin = "anonymous";

        // Convert external images to base64
        if (img.src && !img.src.startsWith("data:")) {
          try {
            const base64 = await imageUrlToBase64(img.src);
            if (base64) {
              img.src = base64;
            }
          } catch (error) {
            console.warn("Failed to convert image:", img.src, error);
          }
        }

        // Ensure image dimensions are set
        if (!img.style.width && img.naturalWidth) {
          img.style.width = img.naturalWidth + "px";
        }
        if (!img.style.height && img.naturalHeight) {
          img.style.height = img.naturalHeight + "px";
        }
      }
    }
  },
});

/**
 * Wait for images to load
 */
const waitForImages = (element) => {
  const images = element.querySelectorAll("img");
  const promises = Array.from(images).map((img) => {
    if (img.complete) return Promise.resolve();
    return new Promise((resolve) => {
      img.onload = resolve;
      img.onerror = resolve; // Continue even if image fails
      setTimeout(resolve, 3000);
    });
  });
  return Promise.all(promises);
};

/**
 * Generate canvas from element
 */
const generateCanvas = async (element) => {
  if (!element) throw new Error("Element not found");

  await waitForImages(element);
  await new Promise((resolve) => setTimeout(resolve, 200));

  const canvas = await html2canvas(element, getCanvasConfig(element));
  return canvas;
};

/**
 * Download as PNG format
 */
export const downloadAsPNG = async (element, filename) => {
  try {
    const canvas = await generateCanvas(element);
    const blob = await new Promise((resolve) => {
      canvas.toBlob(resolve, "image/png", 1.0);
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = `${filename}.png`;
    link.href = url;
    link.click();

    setTimeout(() => URL.revokeObjectURL(url), 100);
  } catch (error) {
    console.error("Error downloading PNG:", error);
    throw error;
  }
};

/**
 * Download as JPEG format
 */
export const downloadAsJPEG = async (element, filename) => {
  try {
    const canvas = await generateCanvas(element);
    const blob = await new Promise((resolve) => {
      canvas.toBlob(resolve, "image/jpeg", 0.95);
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = `${filename}.jpeg`;
    link.href = url;
    link.click();

    setTimeout(() => URL.revokeObjectURL(url), 100);
  } catch (error) {
    console.error("Error downloading JPEG:", error);
    throw error;
  }
};

/**
 * Download as PDF format
 */
export const downloadAsPDF = async (element, filename) => {
  try {
    const canvas = await generateCanvas(element);
    const imgData = canvas.toDataURL("image/png", 1.0);

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    const pdfWidth = 200;
    const pdfHeight = (canvasHeight * pdfWidth) / canvasWidth;

    const pdf = new jsPDF({
      orientation: pdfWidth > pdfHeight ? "landscape" : "portrait",
      unit: "mm",
      format: [pdfWidth, pdfHeight],
    });

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight, undefined, "FAST");
    pdf.save(`${filename}.pdf`);
  } catch (error) {
    console.error("Error downloading PDF:", error);
    throw error;
  }
};

/**
 * Download in specified format
 */
export const downloadReceipt = async (element, filename, format) => {
  if (!element) {
    throw new Error("Element not found for download");
  }

  const validFormats = ["png", "jpeg", "jpg", "pdf"];
  const normalizedFormat = format.toLowerCase();

  if (!validFormats.includes(normalizedFormat)) {
    throw new Error(
      `Unsupported format: ${format}. Supported formats: ${validFormats.join(
        ", ",
      )}`,
    );
  }

  try {
    switch (normalizedFormat) {
      case "png":
        await downloadAsPNG(element, filename);
        break;
      case "jpeg":
      case "jpg":
        await downloadAsJPEG(element, filename);
        break;
      case "pdf":
        await downloadAsPDF(element, filename);
        break;
      default:
        throw new Error(`Unsupported format: ${format}`);
    }
  } catch (error) {
    console.error(`Download failed for format ${format}:`, error);
    throw error;
  }
};
